<!--
 * @Description: 结算中心-概要，根据当前开户状态展示不同组件
 * @Date: 2020-11-03 09:41:19
-->
<template>
  <div class="allBox">
    <component
      v-if="currentCom"
      :is="currentCom"
      :type="type"
      :reasons="reasons"
      :authStatus="authStatus"
      :selectBankName="selectBankName"
      @changeComp="changeComp"
    />
    <!--    <router-view name="settlementCenter" />-->
    <!--        <charts style="position: absolute;top:100vh"/>-->
  </div>
</template>
<script>
import importComponents from './utils/importComponents';
import { dictionaries } from '@/api/ajax';
import { mapMutations } from 'vuex';
const modules = importComponents(); //统一引入组件
// 开户状态对应的组件与组件参数
//authStatus 平台审核状态  0  初始化  1 平台审核中 2平台审核失败  3  平台审核通过  4银行审核中 5银行审核失败  6 银行通过
const compByAuthStatusMap = {
  0: { comp: 'step1', type: 0 },
  1: { comp: 'step2', type: 1 },
  2: { comp: 'step2', type: 2 },
  3: { comp: 'step2', type: 3 },
  4: { comp: 'step3', type: 1 },
  5: { comp: 'step3', type: 2 },
  6: { comp: 'dashBoard', type: 0 }
};
export default {
  name: 'settlementCenter',
  data() {
    return {
      currentCom: '',
      type: 0,
      reasons: '',
      selectBankName: '',
      authStatus: 0
    };
  },
  components: {
    ...modules,
    charts: () => import('./components/charts'),
    dashBoard: () => import('./components/dashboard/dashboard')
  },
  methods: {
    ...mapMutations(['INIT_PROJECT_STATE']),
    /**
     * @description: 修改展示组件
     *               有的地方直接使用了$parent.type方式修改，暂未优化处理。
     *               线下支付需要注意，只有开通的页面展示（保持不展示左侧菜单），没有开通中、失败页面，开通中在概况中以按钮状态展示，为了让企业一样可以支付线下订单操作。
     */
    changeComp(v) {
      this.type = v.type;
      this.currentCom = v.currentCom;
      this.selectBankName = v.bankName;
      // this.$store.commit('SET_SHOW_MENUS', this.currentCom === 'dashBoard');
    }
  },
  created() {
    this.INIT_PROJECT_STATE();
    // 获取企业开户状态
    dictionaries.isOpenAccount().then(res => {
      const {
        pdata: { fyAuthStatus, fyReason, zbAuthStatus, zbReason }
      } = res;
      //authStatus 平台审核状态  0  初始化  1 平台审核中 2平台审核失败  3  平台审核通过  4银行审核中 5银行审核失败  6 银行通过
      this.reasons = {
        fyReason,
        zbReason
      };
      let current = compByAuthStatusMap[6];

      this.currentCom = current.comp;
      this.type = current.type;
      this.authStatus = {
        fyAuthStatus: +fyAuthStatus,
        zbAuthStatus: +zbAuthStatus
      };
      // 设置当前用户是否开通了，未开通则不显示菜单与导航
      // this.$store.commit('SET_SHOW_MENUS', this.currentCom === 'dashBoard');
    });
  }
};
</script>
<style lang="scss" scoped>
.allBox {
  //background: #fff;
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
